(() => {
  const SIZE_MARKERS = ['135x200', '200x200'];

  function normalize(value = '') {
    return value
      .toLowerCase()
      .replaceAll('×', 'x')
      .replace(/\s+/g, '');
  }

  function getSelectedSize(productInfo) {
    const selectedValues = [];

    productInfo
      .querySelectorAll(
        'variant-selects select, variant-radios input:checked, input[type="radio"]:checked'
      )
      .forEach((element) => {
        selectedValues.push(element.value || element.textContent || '');
      });

    const selectedText = normalize(selectedValues.join(' '));

    return SIZE_MARKERS.find((size) => selectedText.includes(size)) || null;
  }

  function getMediaSize(element) {
    const image = element.querySelector('img');

    if (!image) return null;

    const imageData = normalize(
      [
        image.currentSrc,
        image.src,
        image.getAttribute('srcset'),
        image.getAttribute('alt'),
      ].join(' ')
    );

    return SIZE_MARKERS.find((size) => imageData.includes(size)) || null;
  }

  function setElementVisibility(element, visible) {
    element.hidden = !visible;
    element.style.display = visible ? '' : 'none';
    element.setAttribute('aria-hidden', visible ? 'false' : 'true');
  }

  function filterProductGallery(productInfo) {
    const selectedSize = getSelectedSize(productInfo);

    if (!selectedSize) return;

    const sectionId = productInfo.dataset.section;
    const gallery =
      productInfo.querySelector('media-gallery') ||
      document.querySelector(`#MediaGallery-${sectionId}`);

    if (!gallery) return;

    const galleryItems = gallery.querySelectorAll(
      '[id^="Slide-"], [id^="Thumbnail-"]'
    );

    galleryItems.forEach((item) => {
      const mediaSize = getMediaSize(item);

      // Bilder ohne Größenangabe bleiben bei beiden Varianten sichtbar.
      const shouldShow = !mediaSize || mediaSize === selectedSize;

      setElementVisibility(item, shouldShow);
    });

    // Auch Bilder im vergrößerten Produktbild-Popup filtern.
    const modal = document.querySelector(`#ProductModal-${sectionId}`);

    modal?.querySelectorAll('[data-media-id], .product-media-modal__content > *')
      .forEach((item) => {
        const mediaSize = getMediaSize(item);
        const shouldShow = !mediaSize || mediaSize === selectedSize;

        setElementVisibility(item, shouldShow);
      });

    const visibleSlides = Array.from(
      gallery.querySelectorAll('[id^="Slide-"]')
    ).filter((item) => !item.hidden);

    const activeSlide = gallery.querySelector(
      '[id^="Slide-"].is-active:not([hidden])'
    );

    // Falls das bisher aktive Bild zur anderen Größe gehört:
    if (!activeSlide && visibleSlides.length > 0) {
      const firstVisibleSlide = visibleSlides[0];
      const mediaId = firstVisibleSlide.dataset.mediaId;

      if (mediaId && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
      } else {
        firstVisibleSlide.classList.add('is-active');
      }
    }

    // Dawn-Slider nach dem Ausblenden neu berechnen.
    const viewer = gallery.querySelector('[id^="GalleryViewer"]');
    const thumbnails = gallery.querySelector('[id^="GalleryThumbnails"]');

    viewer?.resetPages?.();
    thumbnails?.resetPages?.();
  }

  function filterAllProductGalleries() {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      filterProductGallery(productInfo);
    });
  }

  function runFilter() {
    window.requestAnimationFrame(() => {
      filterAllProductGalleries();

      // Dawn ersetzt beim Variantenwechsel Teile des Produktbereichs.
      window.setTimeout(filterAllProductGalleries, 100);
      window.setTimeout(filterAllProductGalleries, 400);
    });
  }

  document.addEventListener('DOMContentLoaded', runFilter);
  document.addEventListener('change', runFilter);

  // Unterstützt dynamisch neu geladene Produktbereiche.
  const observer = new MutationObserver((mutations) => {
    const productAreaChanged = mutations.some((mutation) =>
      Array.from(mutation.addedNodes).some(
        (node) =>
          node.nodeType === Node.ELEMENT_NODE &&
          (node.matches?.('product-info, media-gallery') ||
            node.querySelector?.('product-info, media-gallery'))
      )
    );

    if (productAreaChanged) {
      runFilter();
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();